import { createFileRoute } from "@tanstack/react-router";
import GhidCumparatori from "@/pages/GhidCumparatori";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/ghid-cumparatori/")({
  head: () => routeHead("/ghid-cumparatori/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <GhidCumparatori />
  );
}
